import { SettingConst } from '../../types';

/**
 * Enable POS inventory counts on PDP, third relaunch
 */
export const PDP_INVENTORY_COUNTS_RELAUNCH_3_250107 =
  'PDP_INVENTORY_COUNTS_RELAUNCH_3_250107' as SettingConst<
    'PDP_INVENTORY_COUNTS_RELAUNCH_3_250107',
    boolean,
    'LOGGED_IN_RETAILER'
  >;
